import React from 'react';
import { Box, Text, Link } from '@primer/react';
import { RepoIcon, LinkExternalIcon } from '@primer/octicons-react';
import projectsData from '../data/projectsData';

const Projects = () => {
    return (
        <Box mb={6}>
            <Box mt={5} mb={4}>
                <Text
                    as="p"
                    color="fg.muted"
                    sx={{ fontSize: 1 }}
                >

                </Text>
            </Box>

            <Box
                    bg="accent.subtle"
                    p={4}
                    borderRadius={2}
                    border="1px solid"
                    borderColor="accent.muted"
                    mb={4}
                >
                    <Link href="https://www.github.com/dylanca" sx={{ color: 'accent.fg' }}>
                        <Text
                            sx={{
                                fontSize: [1, 2],
                                color: 'accent.fg',
                                lineHeight: 1.5
                            }}
                        >
                        Checkout my <b>Github Profile</b> for an up-to-date, more detailed list of my projects.
                        </Text>
                    </Link>
                </Box>
            <Box display="flex" flexDirection="column" gap={8}>
                {projectsData.map(project => (
                    <Link
                        key={project.id}
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            textDecoration: 'none',
                            color: 'fg.default',
                            display: 'block',
                            '&:hover': {
                                textDecoration: 'none'
                            }
                        }}
                    >
                        <Box
                            padding={[3, 4]}
                            mt={3}
                            borderRadius={2}
                            border="1px solid"
                            borderColor="border.default"
                            bg="canvas.subtle"
                            sx={{
                                '&:hover': {
                                    borderColor: 'accent.muted',
                                    bg: 'canvas.inset',
                                    transition: 'all 0.2s ease'
                                }
                            }}
                        >
                            <Box display="flex" alignItems="flex-start" justifyContent="space-between">
                                <Box>
                                    <Text
                                        fontSize={2}
                                        fontWeight="bold"
                                        color="fg.default"
                                        mb={3}
                                        display="flex"
                                        alignItems="center"
                                    >
                                        <Box mr={2}><RepoIcon size={16} /></Box>

                                        {project.title}
                                    </Text>
                                    <Text fontSize={1} color="fg.muted" mb={2}>
                                        {project.description}
                                    </Text>
                                </Box>
                                <Box
                                    sx={{
                                        color: 'accent.fg',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <LinkExternalIcon size={16} />
                                </Box>
                            </Box>

                            <Box display="flex" flexWrap="wrap" gap={3} mt={3}>
                                {project.techStack.map((tech, index) => (
                                    <Box
                                        key={index}
                                        fontSize={0}
                                        px={2}
                                        py={1}
                                        borderRadius="2em"
                                        bg="canvas.default"
                                        color="fg.muted"
                                        border="1px solid"
                                        borderColor="border.muted"
                                        mr={1}
                                    >
                                        {tech}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Link>
                ))}
            </Box>
        </Box>
    );
};

export default Projects;